module.exports = __webpack_public_path__ + "static/Sematext-fb32c4caacda9168ef004b1e025e21a3.svg";